// Type-only import — erased at compile time, so this file stays free of any
// runtime @sentry/* dependency and safe to import from eager, non-lazy code.
import type { Event } from '@sentry/core';

export type PostCaptureHook = (event: Event) => void;

const postCaptureHooks: PostCaptureHook[] = [];

// Lets features (e.g. the feedback widget) react to every captured error
// without `init.ts` knowing about them.
export function registerPostCaptureHook(hook: PostCaptureHook) {
  postCaptureHooks.push(hook);
}

export function runPostCaptureHooks(event: Event) {
  for (const hook of postCaptureHooks) {
    try {
      hook(event);
    } catch {
      // A misbehaving hook must not block the rest, or Sentry's own event dispatch.
    }
  }
}
